import { render, staticRenderFns } from "./customer_table.vue?vue&type=template&id=3fd059b5&scoped=true"
import script from "./customer_table.vue?vue&type=script&lang=js"
export * from "./customer_table.vue?vue&type=script&lang=js"
import style0 from "./customer_table.vue?vue&type=style&index=0&id=3fd059b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd059b5",
  null
  
)

export default component.exports